/* JS AJOUTE */

// Custom js
jQuery(document).ready(function($) {

  /* Owl Carousel */

  function owlCallback() {
    $('.header-frontpage .o-container').addClass('js-is-appendTo').appendTo('.slider-frontpage');
    setTimeout(function(){
      $('.header-frontpage-contents').next('div').addClass('mouse-scroll').removeClass('hidden');
    }, 1000);
  }

  // Frontpage
  $('.slider-frontpage').owlCarousel({
    autoplay: true,
    autoplayTimeout: 8000,
    loop: true,
    items: 1,
    smartSpeed: 2000,
    nav: true,
    navText: ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
    onInitialized: owlCallback
  });

  // Frontpage - Carousel des réalisations
  $('.slider-realisations').owlCarousel({
    autoplay: true,
    autoplayTimeout: 5000,
    loop: true,
    items: 3,
    smartSpeed: 1000,
    nav: true,
    navText: ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
    responsiveClass: true,
    responsive: {
      1: {
        items: 1
      },
      769: {
        items: 2
      },
      1281: {
        items: 3
      }
    }
  });

  // Posts Actualités et Réalisations
  $('.slider-single').owlCarousel({
    autoplay: true,
    autoplayTimeout: 7000,
    loop: true,
    smartSpeed: 1500,
    responsiveClass: true,
    responsive: {
      1: {
        items: 1
      },
      681: {
        items: 2
      },
      1281: {
        items: 1
      }
    }
  });

  /* Ajoute un style aux mots de la liste des informations clés (d'une réalisation ou actualité)
  ** précédant un ":"
  */
  if ( $('.project-info-list ul li, .page:not(.home):not(.page-id-114) main ul li, .single main ul li').length ) {
    $('.project-info-list ul li, .page main ul li, .single main ul li').each(function() {
      var infoItem = $(this).html();
      var http = infoItem.indexOf('http:');
      var https = infoItem.indexOf('https:');
      var infoTitleIndex = infoItem.indexOf(':');
      var infoTitle = infoItem.substring(0, infoTitleIndex + 1);
      var infoContent = infoItem.substring(infoTitleIndex + 1);

      if (infoTitleIndex > 0 && http <= 0 && https <= 0) {
        $(this).addClass('js-has-b-tag').html('<b>' + infoTitle + '</b>' + infoContent);
      }
    });
  }

  //Premier lettre du paragraphe de la section Qui sommes-nous ? de la page d'accueil
  if ( $('.section-about').length ) {
    var aboutText = $('.section-about article > p').html();
    var firstLetter = aboutText.substring(0, 1);

    $('head').append('<style>.section-about article > p:before { content:"' + firstLetter + '";}</style>');
  }

  // Ajoute un id aux H2 des pages non dynamiques, pour un système d'ancres
  if ( $('.page:not(.home) h2').length ) {
    $('.page h2').each(function() {
      var text = $(this).html().toLowerCase();

      var accent = [
        /[\300-\306]/g, /[\340-\346]/g, // A, a
        /[\310-\313]/g, /[\350-\353]/g, // E, e
        /[\314-\317]/g, /[\354-\357]/g, // I, i
        /[\322-\330]/g, /[\362-\370]/g, // O, o
        /[\331-\334]/g, /[\371-\374]/g, // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
      ];
      var noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

      for(var i = 0; i < accent.length; i++){
          text = text.replace(accent[i], noaccent[i]);
      }

      var id = text.replace(/ /g, '-').replace(/’/g, '-');

      $(this).addClass('js-has-id').attr('id', id);
    });
  }

  // Header fix de la frontpage
  if ( $('.header-frontpage-fixed').length && $(window).width() > 768 ) {
    var limit = $('.header-frontpage').height() - 110;
    var resetLimit = true;
    var resetWindowWidth = true;

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var windowWidth;

      if ( resetWindowWidth ) {
        windowWidth = $(window).width();
      }

      if ( windowWidth > 768 ) {
        if ( resetLimit ) {
          limit = $('.header-frontpage').height() - 110;
        }

        if ( scroll >= limit ) {
          $('.header-frontpage-fixed').addClass('js-is-sticky sticky');
        }

        else if ( scroll < limit ) {
          $('.header-frontpage-fixed').removeClass('js-is-sticky sticky');
        }
      }
    });
  }

  // Enlève le slider de la frontpage lorsque largeur d'écran < 768 et display le petit
  if ( $('.header-frontpage').length ) {
    if ( $(window).width() <= 768 ) {
      $('.header-frontpage-fixed').addClass('js-is-displayed displayed');
      $('.header-frontpage').addClass('js-is-hidden hidden');
    }

    var resetWindowWidth2 = true;
    var windowWidth;

    $(window).resize( function() {
      if ( resetWindowWidth2 ) {
        windowWidth = $(window).width();
      }

      if ( windowWidth <= 768 ) {
        $('.header-frontpage-fixed').addClass('js-is-displayed');
        $('.header-frontpage-fixed').removeClass('js-is-sticky sticky');
      }

      else if ( windowWidth > 768 ) {
        $('.header-frontpage-fixed').removeClass('js-is-displayed');
        $('.header-frontpage').remove('js-is-hidden hidden');
      }
    });
  }

  // Bouton menu hamburger
  if ( $(window).width() <= 768 ) {
    $('.c-responsive-btn').addClass('js-is-displayed displayed');
  }

  else if ( $(window).width() > 768 ) {
    $('.c-responsive-btn').removeClass('js-is-displayed displayed');
  }

  $('.c-responsive-btn').click( function() {
    $('.header-pages-content').slideToggle();
    $('.breadcrumbs').toggleClass('hidden');
    $(this).html($(this).text() === 'Fermer' ? 'Menu' : 'Fermer');
  });
});
